<div class="dropdown language-switcher">
  <button type="button" class="language-switcher__button dropdown-toggle" :class="{ 'language-switcher__button--footer': footer }" data-bs-toggle="dropdown" aria-expanded="false" :aria-label="$t('language.label')">
    {{ currentLocale.toUpperCase() }}
  </button>
  <ul class="dropdown-menu dropdown-menu-end">
    <li v-for="locale in availableLocales" :key="locale">
      <button type="button" class="dropdown-item language-switcher__option" :class="{ 'is-active': locale === currentLocale }" @click="selectLocale(locale)">
        <span>{{ $t(`language.${locale}`) }}</span>
        <i v-if="locale === currentLocale" class="bi bi-check-lg" aria-hidden="true"></i>
      </button>
    </li>
  </ul>
</div>
